import {crypt, decrypt} from './crypt';

const TOKEN_KEY = 'qmndg';
const COMPANY_KEY = 'lkdfg';
const FINANCIAL_TYPE = 'uiet';
const FINANCIAL_TYPE_NAME = 'kdals';
const USER_ID_KEY = 'jxcv';
const ROL_ID_KEY = 'piuo';
const USER_NAME_KEY = 'qlaks';

export const putValue = (key, value) => {
    window.localStorage.setItem(key, crypt(value.toString()));
}

export const getValue = (key) => {
    let data = window.localStorage.getItem(key);
    if(data != null) return decrypt(data);
    else return data;
}

export const cleanValue = (key) => {
    window.localStorage.removeItem(key);
}

export const cleanValues = () => {
    window.localStorage.clear();
}

export const putToken = (token) => {
    putValue(TOKEN_KEY, token);
}

export const getToken = () => {
    return getValue(TOKEN_KEY);
}

export const putCompany = (id) => {
    putValue(COMPANY_KEY, id);
}

export const getCompany = () => {
    return getValue(COMPANY_KEY);
}

export const putUserName = (value) => {
    putValue(USER_NAME_KEY, value);
}

export const getUserName = () => {
    return getValue(USER_NAME_KEY);
}

export const putFinancialType = (id) => {
    putValue(FINANCIAL_TYPE, id);
}

export const getFinancialType = () => {
    return getValue(FINANCIAL_TYPE);
}

export const putFinancialTypeName = (name) => {
    putValue(FINANCIAL_TYPE_NAME, name);
}

export const getFinancialTypeName = () => {
    return getValue(FINANCIAL_TYPE_NAME);
}

export const putUserId = (id) => {
    putValue(USER_ID_KEY, id);
}

export const getUserId = () => {
    return getValue(USER_ID_KEY);
}

export const putRol = (id) => {
    putValue(ROL_ID_KEY, id);
}

export const getRol = () => {
    return getValue(ROL_ID_KEY);
}